import React from 'react';
import PropTypes from 'prop-types';

export default function CirclePlusIcon({ width, height, color }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
    >
      <path
        d="M13.5 0C10.83 0 8.21987 0.791761 5.99981 2.27516C3.77974 3.75856 2.04942 5.86697 1.02763 8.33377C0.00584933 10.8006 -0.261496 13.515 0.259405 16.1337C0.780305 18.7525 2.06606 21.1579 3.95406 23.0459C5.84207 24.9339 8.24754 26.2197 10.8663 26.7406C13.485 27.2615 16.1994 26.9942 18.6662 25.9724C21.133 24.9506 23.2414 23.2203 24.7248 21.0002C26.2082 18.7801 27 16.17 27 13.5C27 11.7272 26.6508 9.97167 25.9724 8.33377C25.2939 6.69588 24.2995 5.20765 23.0459 3.95406C21.7924 2.70047 20.3041 1.70606 18.6662 1.02763C17.0283 0.349188 15.2728 0 13.5 0ZM17.55 14.85H14.85V17.55C14.85 17.908 14.7078 18.2514 14.4546 18.5046C14.2014 18.7578 13.858 18.9 13.5 18.9C13.142 18.9 12.7986 18.7578 12.5454 18.5046C12.2922 18.2514 12.15 17.908 12.15 17.55V14.85H9.45C9.09196 14.85 8.74858 14.7078 8.49541 14.4546C8.24224 14.2014 8.1 13.858 8.1 13.5C8.1 13.142 8.24224 12.7986 8.49541 12.5454C8.74858 12.2922 9.09196 12.15 9.45 12.15H12.15V9.45C12.15 9.09196 12.2922 8.74858 12.5454 8.4954C12.7986 8.24223 13.142 8.1 13.5 8.1C13.858 8.1 14.2014 8.24223 14.4546 8.4954C14.7078 8.74858 14.85 9.09196 14.85 9.45V12.15H17.55C17.908 12.15 18.2514 12.2922 18.5046 12.5454C18.7578 12.7986 18.9 13.142 18.9 13.5C18.9 13.858 18.7578 14.2014 18.5046 14.4546C18.2514 14.7078 17.908 14.85 17.55 14.85Z"
        fill={color}
      />
    </svg>
  );
}

CirclePlusIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};

CirclePlusIcon.defaultProps = {
  color: '#CFCFD4',
  width: 27,
  height: 27,
};
